/* eslint-disable */

import { AddOn } from './AddOn';
//import * as wording from '../../../common/js/wording'
import { AddOnType } from '../FbbEnum';
import * as log from '../../../common/js/appLogger';

/*
Pls submit “Z,1” for equipList plus below values (like Norton):

WiFi路由器	VAS Code	標準月費	Mktg code	收費總額	合約期(月)	合約代號	T&C
Asus RT-AC68U	FBRM1	$40	MVZ08	$960	24	LDJ24M40	N003PB
*/
/*
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
copy from AddOnRentalRouterFree
下次改也记得同步AddOnRentalRouterFree
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
*/
export class AddOnRentalRouter95WiFi7 extends AddOn {
	static readonly codesInfo = [
		{
			contract: 3,
			avgPrice: 0,
			ignorePlanCode: false,
			planCodeAllowed: ['5g_hbb_Free3mths'],
			code: 'ADD-ROUTER-3RENT-WPRE',
		},
		{
			contract: 3,
			avgPrice: 0,
			ignorePlanCode: true,
			planCodeAllowed: ['all'],
			code: 'ROUTER-RENTAL',
		},
		{
			contract: 6,
			avgPrice: 0,
			ignorePlanCode: false,
			planCodeAllowed: ['5g_hbb_stu_GRWTH', '5g_hbb_stu_6m'],
			code: 'ADD-ROUTER-6RENT-WPRE',
		},
		{
			contract: 6,
			avgPrice: 0,
			ignorePlanCode: false,
			planCodeAllowed: ['5g_hbb_SIA_6m', '5g_hbb_SCHOOL_6m'],
			code: 'ADD-ROUTER-6RENT-NPRE',
		},
		{
			contract: 6,
			avgPrice: 0,
			ignorePlanCode: true,
			planCodeAllowed: ['all'],
			code: 'ROUTER-RENTAL',
		},	
		{
			contract: 12,
			avgPrice: 0,
			ignorePlanCode: false,
			planCodeAllowed: ['5g_hbb_SCHOOL_12m'],
			code: 'ADD-ROUTER-12RENT',
		},
		{
			contract: 12,
			avgPrice: 0,
			ignorePlanCode: false,
			planCodeAllowed: ['5g_hbb_SIA_12m'],
			code: 'ADD-ROUTER-12RENT-WPRE',
		},
		{
			contract: 12,
			avgPrice: 0,
			ignorePlanCode: true,
			planCodeAllowed: ['all'],
			code: 'ROUTER-RENTAL',
		},
		{
			contract: 24,
			avgPrice: 0,
			ignorePlanCode: true,
			planCodeAllowed: ['all'],	// '5g_hbb_24m_free_rental'
			code: 'ROUTER-RENTAL',
		},
		{
			contract: 36,
			avgPrice: 0,
			ignorePlanCode: true,
			planCodeAllowed: ['all'],	// '5g_hbb_36m_WiFi7'
			code: 'ROUTER-RENTAL',
		}
	];

	protected isBasePlanSelected: boolean = false;
	protected baseVasCode: String = 'ADD-ROUTER-%m%RENT-WPRE';
	protected deposit: number = 1500;

	constructor() {
		super();
		this.key = 'AddOnRentalRouter95WiFi7';

		this.boxIconEn = '';
		this.boxIconZh = '';
		this.boxNameEn = 'Router Rental Wifi7';
		this.boxNameZh = 'Router Rental Wifi7';
		this.boxAmount = 0; // per month
		this.discountAmount = -1; // 3080
		this.hasRedCounter = false;

		this.type = AddOnType.SINGLE;
	}

	public getAmount2(contractMonthSrt: string, planCode: string): Number {
		let option = null;
		let contractMonth: Number = parseInt(contractMonthSrt);
		let displayPriceAmount = this.boxAmount;
		for (var i = 0; i < AddOnRentalRouter95WiFi7.codesInfo.length; i++) {
			if (AddOnRentalRouter95WiFi7.codesInfo[i].contract == contractMonth) {
				if ((AddOnRentalRouter95WiFi7.codesInfo[i].ignorePlanCode ?? false) == true) {
					option = AddOnRentalRouter95WiFi7.codesInfo[i];
					break;
				} else {
					if (AddOnRentalRouter95WiFi7.codesInfo[i].planCodeAllowed.indexOf(planCode) > -1) {
						option = AddOnRentalRouter95WiFi7.codesInfo[i];
						break;
					}
				}
			}
		}

		if (option && option.hasOwnProperty('avgPrice') && option['avgPrice'] != displayPriceAmount) {
			displayPriceAmount = option.avgPrice;
		}

		return displayPriceAmount;
	}

	public getAmount(contractMonthSrt: string): Number {
		let option = null;
		let contractMonth: Number = parseInt(contractMonthSrt);
		let displayPriceAmount = this.boxAmount;
		for (var i = 0; i < AddOnRentalRouter95WiFi7.codesInfo.length; i++) {
			if (AddOnRentalRouter95WiFi7.codesInfo[i].contract == contractMonth) {
				option = AddOnRentalRouter95WiFi7.codesInfo[i];
				break;
			}
		}

		if (option && option.hasOwnProperty('avgPrice') && option['avgPrice'] != displayPriceAmount) {
			displayPriceAmount = option.avgPrice;
		}

		return displayPriceAmount;
	}

	public getDeposit(): Number {
		return this.deposit || 0;
	}

	public getBaseVasCode(): String {
		return this.baseVasCode || '';
	}

	public isAddOnSelected(): boolean {
		return this.boxCount > 0;
	}

	//=================================================================================
	/** no overwrite AddOn one 
    public getData() : any {
        //var data = super.getData()
        return data
    }
    public parse(data: any) {
        //super.parse(data)
    }
    */
	//=================================================================================

	public getPlanVasCode2(contractMonth: Number, planCode: string): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			let option = null;
			for (var i = 0; i < AddOnRentalRouter95WiFi7.codesInfo.length; i++) {
				if (AddOnRentalRouter95WiFi7.codesInfo[i].contract == contractMonth) {
					if ((AddOnRentalRouter95WiFi7.codesInfo[i].ignorePlanCode ?? false) == true) {
						option = AddOnRentalRouter95WiFi7.codesInfo[i];
						break;
					} else {
						if (AddOnRentalRouter95WiFi7.codesInfo[i].planCodeAllowed.indexOf(planCode) > -1) {
							option = AddOnRentalRouter95WiFi7.codesInfo[i];
							break;
						}
					}
				}
			}

			vasCode = option?.code ?? '';
			vasCode = vasCode.replace('%m%', contractMonth.toString());
			return vasCode;
		} else {
			return '';
		}
	}

	public getPlanVasCode(customerType: String, contractMonth: Number): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			let option = null;
			for (var i = 0; i < AddOnRentalRouter95WiFi7.codesInfo.length; i++) {
				if (AddOnRentalRouter95WiFi7.codesInfo[i].contract == contractMonth) {
					option = AddOnRentalRouter95WiFi7.codesInfo[i];
					break;
				}
			}

			vasCode = option?.code ?? '';
			vasCode = vasCode.replace('%m%', contractMonth.toString());
			return vasCode;
		} else {
			return '';
		}
	}

	public getPlanVasCode_old(customerType: String, contractMonth: Number): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			vasCode = this.getBaseVasCode() + '';
			vasCode = vasCode.replace('%m%', contractMonth.toString());
			return vasCode;
		} else {
			return '';
		}
	}
}
